import { render, staticRenderFns } from "./eventCard.vue?vue&type=template&id=0628319a&scoped=true&"
import script from "./eventCard.vue?vue&type=script&lang=js&"
export * from "./eventCard.vue?vue&type=script&lang=js&"
import style0 from "./eventCard.vue?vue&type=style&index=0&id=0628319a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628319a",
  null
  
)

export default component.exports